import gql from 'graphql-tag';

export default gql`
  mutation adminDeleteApplication($input: AdminDeleteApplicationInput!) {
    adminDeleteApplication(input: $input)
  }
`;
